import { useUserOrganization, useUserOrganizationSettings } from '@modules-deprecated/app/organization'

import { LabsFlag } from '../../../enums/labsFlag'
import { useLabsMenuFlags } from '../../../hooks/useLabsMenuFlags'

interface UseReviewEntriesFeatureResult {
  hasOrganization: boolean
  isEnabled: boolean
  isLoading: boolean
}

export const useReviewEntriesFeature = (): UseReviewEntriesFeatureResult => {
  const { isLoading: isOrganizationLoading, organization } = useUserOrganization()
  const { isLoading: isSettingsLoading, isPreviousData } = useUserOrganizationSettings()
  const labsFlags = useLabsMenuFlags()

  const hasOrganization = !!organization?.id
  // still resolving either the organization or its settings — callers should render a loading
  // skeleton rather than committing to the "no organization" branch prematurely
  const isLoading = isOrganizationLoading || (hasOrganization && (isSettingsLoading || isPreviousData))
  // hidden in production for everyone — developer-only labs flag until the feature ships (ADVP-308)
  const isEnabled = hasOrganization && !isSettingsLoading && !isPreviousData && labsFlags[LabsFlag.ExpertReviewEntries]

  return { hasOrganization, isEnabled, isLoading }
}
